export default __webpack_public_path__ + "static/tade-ajiboye-3476d3ca457fdd0d3dda49705512c08d.png";